import React, { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import { Heading, Field, Flex } from '@oliasoft-open-source/react-ui-library';
import { getResolver } from 'src/validation/resolver';
import translations from 'src/internationalisation/translation-map.json';
import { Input, Select } from 'client/common/form-inputs';
import { settingsCategoriesSchemaValidator } from 'schemas/ajv-validators';
import { useAutoSave } from 'client/common/auto-save/use-auto-save';
import { autoSaveWait } from 'src/config/config';
import { mapNameToCode, validateValue } from 'src/views/cost-setup/helpers/check-for-valid-id';

const CostCategoryForm = ({
  category,
  templates,
  selectedId,
  entity,
  updateCostCategory,
  costCodesCategories,
  costCodesIdToCodeAndNameMap,
  costCodesCodeAndNameToIdMap,
}) => {
  const { t } = useTranslation();
  const { company: companyId } = useParams();

  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      costCategoryId: category?.costCategoryId || null,
      name: category?.name || '',
      parentId: null,
      costCodesId: category?.costCodesId || null,
    },
    resolver: getResolver(settingsCategoriesSchemaValidator),
  });

  useEffect(() => {
    const data = { ...category };
    reset({
      ...data,
      costCodesId: validateValue(data?.costCodesId, costCodesCategories, costCodesIdToCodeAndNameMap),
    });
  }, [category?.costCategoryId]);

  const debounceAddCategory = useRef(debounce(updateCostCategory, autoSaveWait));
  const onSubmit = handleSubmit((data) => {
    const updatedData = { ...data };
    updatedData.costCodesId = mapNameToCode(updatedData.costCodesId, costCodesCodeAndNameToIdMap);
    debounceAddCategory.current(updatedData, templates, selectedId, entity, companyId);
  });
  useAutoSave(onSubmit, watch);

  return (
    <>
      <Heading top>{t(translations.categoryDetails)}</Heading>
      <form>
        <Flex gap>
          <Field label={t(translations.name)}>
            <Input
              testId="automation-rulesets-input-name"
              name="name"
              control={control}
              errors={errors}
              width="258px"
            />
          </Field>
          <Field label={t(translations.code)}>
            <Select
              testId="automation-rulesets-select-code"
              name="costCodesId"
              control={control}
              errors={errors}
              options={costCodesCategories}
              width="300px"
              disabled={category?.parentId}
              clearable
            />
          </Field>
        </Flex>
      </form>
    </>
  );
};

export { CostCategoryForm };
